/**
 * useActiveSubscription Hook
 *
 * React Query hook for fetching the active subscription.
 * Returns null if no active subscription exists.
 */

import { useQuery } from '@tanstack/react-query';
import { getActiveSubscription } from '@/api/subscriptions';
import type { Subscription } from '@/api/subscriptions';

export function useActiveSubscription() {
  return useQuery<Subscription | null, Error>({
    queryKey: ['active-subscription'],
    queryFn: getActiveSubscription,
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 1,
  });
}
